module.exports = __webpack_public_path__ + "static/media/screenshot-whonext2x.3377fcfa.png";